import * as React from 'react';

export interface IAuthTitleProps {
  title: string | JSX.Element;
}

export default function AuthTitle(props: IAuthTitleProps) {
  const { title } = props;
  return <h1 className="font-semibold mb-2 text-lg">{title}</h1>;
}
